import * as React from "react";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";

interface SimpleSwitchProps {
  name: any;
  label: any;
  value: any;
  legendText?: any;
  helperText?: any;
  disabled?: boolean;
  onChange: any;
}

export default function SimpleSwitch({
  name,
  label,
  value,
  legendText,
  helperText,
  disabled = false,
  onChange,
}: SimpleSwitchProps) {
  return (
    <FormControl component="fieldset" variant="standard" disabled={disabled}>
      {legendText && (
        <FormLabel style={{ fontSize: 14 }} component="legend">
          {legendText}
        </FormLabel>
      )}
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={value}
              onChange={onChange}
              name={name}
              disabled={disabled}
            />
          }
          label={label}
        />
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
